import type React from "react"
import { useTranslation } from "react-i18next"

import { FormSelectField } from "@/nzds/forms/form-select-field/form-select-field"
import { useCurrencies } from "@/services/currency"
import { buildStringSelectOptions } from "@/utils/build-string-select-options"
import { EMPTY_DATA_PLACEHOLDER } from "@/utils/constants"

interface CurrencyFieldProps {
  /** The record's stored currency, kept as an option even when the list lacks it */
  currentValue?: string | null
  disabled?: boolean
}

/** The currency select of a form with a `currency` field; it loads its own options */
export const CurrencyField: React.FC<CurrencyFieldProps> = ({
  currentValue,
  disabled = false,
}) => {
  const { t } = useTranslation("common")
  const { currenciesData, currenciesIsFetching } = useCurrencies()

  return (
    <FormSelectField
      disabled={disabled}
      label={t("fields.currency.title")}
      name="currency"
      options={buildStringSelectOptions(
        (currenciesData ?? []).map((currency) => currency.alphaCode),
        currentValue,
        { label: EMPTY_DATA_PLACEHOLDER, value: "" }
      )}
      // A disabled field is dropped from the submission, so loading must not disable it
      readOnly={currenciesIsFetching}
      variant="stacked"
    />
  )
}
